import { render, staticRenderFns } from "./EggsDetailModal.vue?vue&type=template&id=09a67b29&scoped=true"
import script from "./EggsDetailModal.vue?vue&type=script&lang=js"
export * from "./EggsDetailModal.vue?vue&type=script&lang=js"
import style0 from "./EggsDetailModal.vue?vue&type=style&index=0&id=09a67b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a67b29",
  null
  
)

export default component.exports